var map = {
	"./01.png": 3288,
	"./02.png": 9043,
	"./03.png": 186,
	"./04.png": 7061,
	"./05.png": 4172,
	"./06.png": 2279,
	"./07.png": 6702,
	"./08.png": 8617,
	"./09.png": 2368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1202;